export default __webpack_public_path__ + "static/media/addSongDark.14a51e16.svg";